/*
  Article table of contents (snippets/article-toc.liquid).

  Builds the list from H2/H3 headings inside .article__rte, adds IDs only to
  headings that don't have one, scrolls below the sticky header and highlights
  the section currently being read. Article content is otherwise untouched.
*/
(function () {
  var HEADING_GAP = 20;
  // Position of the reading line within the visible area below the sticky header (0 = top, 1 = bottom).
  var READING_LINE = 0.33;
  var instances = [];

  // Visible height of the sticky header once the page is scrolled. On desktop the theme sticks
  // the header with a negative top, so only part of it stays visible. Measured from the header's
  // own styles because the theme's CSS variables are set later by theme.js (and the theme's
  // scroll-padding rule targets a class that is never set).
  function stickyHeaderHeight() {
    var header = document.querySelector('.header__outer-wrapper');
    if (!header) return 0;

    var style = getComputedStyle(header);
    if (style.position !== 'sticky' && style.position !== 'fixed') return 0;

    return Math.max(0, header.offsetHeight + (parseFloat(style.top) || 0));
  }

  // Document position from layout (offsetTop chain). Unlike getBoundingClientRect it ignores
  // the theme's reveal animation transform on .article__content, which would offset the result.
  function documentTop(element) {
    var top = 0;
    while (element) {
      top += element.offsetTop;
      element = element.offsetParent;
    }
    return top;
  }

  function slugify(text) {
    var slug = text.toLowerCase();
    if (slug.normalize) slug = slug.normalize('NFKD').replace(/[̀-ͯ]/g, '');
    try {
      slug = slug.replace(new RegExp('[^\\p{L}\\p{N}]+', 'gu'), '-');
    } catch (e) {
      slug = slug.replace(/[^a-z0-9]+/g, '-');
    }
    return slug.replace(/^-+|-+$/g, '') || 'section';
  }

  function uniqueId(base) {
    var id = base;
    var index = 2;
    while (document.getElementById(id)) {
      id = base + '-' + index;
      index++;
    }
    return id;
  }

  function headingText(heading) {
    return (heading.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function createLink(heading) {
    var link = document.createElement('a');
    link.className = 'article-toc__link';
    link.href = '#' + encodeURIComponent(heading.id);
    link.setAttribute('data-article-toc-target', heading.id);
    link.textContent = headingText(heading);
    return link;
  }

  function buildList(list, headings) {
    var currentItem = null;
    var sublist = null;

    headings.forEach(function (heading) {
      var item = document.createElement('li');
      var isSub = heading.tagName === 'H3' && currentItem;

      item.className = 'article-toc__item article-toc__item--' + (isSub ? 'h3' : 'h2');
      item.appendChild(createLink(heading));

      if (isSub) {
        if (!sublist) {
          // The wrapper lets CSS animate the collapsed/expanded height.
          var subwrap = document.createElement('div');
          subwrap.className = 'article-toc__subwrap';
          sublist = document.createElement('ol');
          sublist.className = 'article-toc__sublist';
          subwrap.appendChild(sublist);
          currentItem.appendChild(subwrap);
        }
        sublist.appendChild(item);
      } else {
        list.appendChild(item);
        currentItem = heading.tagName === 'H2' ? item : null;
        sublist = null;
      }
    });
  }

  function init(container) {
    var scope = container.closest('.article__content') || document;
    var content = scope.querySelector('.article__rte');
    var includeH3 = container.getAttribute('data-include-h3') === 'true';
    var minItems = parseInt(container.getAttribute('data-min-items'), 10) || 1;
    var details = container.querySelector('[data-article-toc-details]');
    var lists = container.querySelectorAll('[data-article-toc-list]');

    var headings = content
      ? Array.prototype.filter.call(content.querySelectorAll(includeH3 ? 'h2, h3' : 'h2'), function (heading) {
          return headingText(heading) !== '';
        })
      : [];

    if (headings.length < minItems) {
      container.hidden = true;
      if (scope.classList) scope.classList.remove('article__content--toc-sidebar');
      return null;
    }

    headings.forEach(function (heading) {
      if (!heading.id) heading.id = uniqueId(slugify(headingText(heading)));
    });

    Array.prototype.forEach.call(lists, function (list) {
      buildList(list, headings);
    });

    var links = container.querySelectorAll('[data-article-toc-target]');
    var currentLabel = container.querySelector('[data-article-toc-current]');
    var activeId = null;
    var ticking = false;

    // Height of the "Contents" bar while it is pinned below the header (mobile/tablet,
    // or desktop without room for the sidebar). Zero in the desktop sidebar layout.
    function barHeight() {
      if (!details || getComputedStyle(container).position !== 'sticky') return 0;
      return details.offsetHeight;
    }

    // Distance from the top of the window to where a heading should land.
    function topOffset() {
      return stickyHeaderHeight() + barHeight() + HEADING_GAP;
    }

    function setActive(id) {
      if (id === activeId) return;
      activeId = id;

      if (currentLabel) {
        var heading = id ? document.getElementById(id) : null;
        currentLabel.textContent = heading ? headingText(heading) : '';
      }

      Array.prototype.forEach.call(links, function (link) {
        var isActive = link.getAttribute('data-article-toc-target') === id;
        link.classList.toggle('is-active', isActive);
        if (isActive) {
          link.setAttribute('aria-current', 'true');
        } else {
          link.removeAttribute('aria-current');
        }
      });

      // Expand the H2 item that is active or contains the active H3; with the
      // "collapse" setting on, CSS only shows the sub-items of expanded items.
      Array.prototype.forEach.call(container.querySelectorAll('.article-toc__item--h2'), function (item) {
        item.classList.toggle('is-expanded', !!item.querySelector('.is-active'));
      });

      // Keep the active item visible inside the scrollable sidebar without scrolling the page.
      var sidebarList = container.querySelector('.article-toc__sidebar .article-toc__list');
      var activeLink = sidebarList && sidebarList.querySelector('.is-active');
      if (activeLink && sidebarList.scrollHeight > sidebarList.clientHeight) {
        var linkTop = activeLink.offsetTop - sidebarList.offsetTop;
        if (linkTop < sidebarList.scrollTop || linkTop + activeLink.offsetHeight > sidebarList.scrollTop + sidebarList.clientHeight) {
          var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          sidebarList.scrollTo({ top: linkTop - sidebarList.clientHeight / 3, behavior: reduceMotion ? 'auto' : 'smooth' });
        }
      }
    }

    var headerHeight = null;
    // After a TOC click the chosen item stays active until the reader scrolls themselves,
    // so the highlight doesn't run through the sections passed by the smooth scroll.
    var clickedId = null;

    function releaseClicked() {
      clickedId = null;
    }

    function updateActive() {
      ticking = false;

      // Keep the sticky bar/sidebar just below the header, whatever its current height.
      var header = stickyHeaderHeight();
      if (header !== headerHeight) {
        headerHeight = header;
        container.style.setProperty('--article-toc-header', header + 'px');
        container.style.setProperty('--article-toc-top', header + HEADING_GAP + 4 + 'px');
      }

      var offset = topOffset();

      if (clickedId) {
        setActive(clickedId);
        return;
      }

      // A section runs from its heading to the next heading (the last one to the end of the text).
      // The active section is the one crossing a reading line a third of the way down the visible
      // area below the header: a section barely showing at the top is not active yet, and short
      // sections still become active while they pass the line instead of being skipped.
      var viewTop = window.scrollY + offset - HEADING_GAP;
      var viewBottom = window.scrollY + window.innerHeight;
      var line = viewTop + (viewBottom - viewTop) * READING_LINE;
      var contentBottom = documentTop(content) + content.offsetHeight;
      var current = null;

      for (var i = 0; i < headings.length; i++) {
        if (documentTop(headings[i]) <= line) {
          current = headings[i];
        } else {
          break;
        }
      }

      // Nothing is active once the text has scrolled out of view (sharing, pagination, footer).
      if (contentBottom <= viewTop) current = null;

      setActive(current ? current.id : null);
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(updateActive);
      }
    }

    function scrollToHeading(heading, smooth) {
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var top = documentTop(heading) - topOffset();

      window.scrollTo({ top: Math.max(top, 0), behavior: smooth && !reduceMotion ? 'smooth' : 'auto' });

      // Move focus for keyboard and screen reader users without a second jump.
      if (!heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1');
      heading.focus({ preventScroll: true });
    }

    function onClick(event) {
      var link = event.target.closest('[data-article-toc-target]');
      if (!link) return;

      var heading = document.getElementById(link.getAttribute('data-article-toc-target'));
      if (!heading) return;

      event.preventDefault();

      if (details && details.contains(link)) closeDetails(true);

      if (window.history && window.history.replaceState) {
        window.history.replaceState(window.history.state, '', '#' + encodeURIComponent(heading.id));
      }
      clickedId = heading.id;
      scrollToHeading(heading, true);
      setActive(heading.id);
    }

    function closeDetails(focusSummary) {
      if (!details || !details.open) return;
      details.open = false;
      if (focusSummary) details.querySelector('summary').focus({ preventScroll: true });
    }

    // The open list overlays the article, so close it with Escape or a tap/click outside.
    function onKeydown(event) {
      if (event.key === 'Escape' && details && details.open) closeDetails(true);
    }

    function onDocumentClick(event) {
      if (details && details.open && !details.contains(event.target)) closeDetails(false);
    }

    var releaseEvents = ['wheel', 'touchstart', 'keydown', 'mousedown'];

    container.addEventListener('click', onClick);
    document.addEventListener('keydown', onKeydown);
    document.addEventListener('click', onDocumentClick);
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    releaseEvents.forEach(function (type) {
      window.addEventListener(type, releaseClicked, { passive: true });
    });
    container.classList.add('article-toc--ready');
    updateActive();

    // IDs are created after load, so the browser could not jump to a shared #hash itself.
    if (window.location.hash) {
      var target = null;
      try {
        target = document.getElementById(decodeURIComponent(window.location.hash.slice(1)));
      } catch (e) {}
      if (target && headings.indexOf(target) !== -1) {
        scrollToHeading(target, false);
        // Images above the heading can still change the layout until the page has loaded.
        if (document.readyState !== 'complete') {
          var userScrolled = false;
          var markScrolled = function () {
            userScrolled = true;
          };
          ['wheel', 'touchstart', 'keydown'].forEach(function (type) {
            window.addEventListener(type, markScrolled, { once: true, passive: true });
          });
          window.addEventListener('load', function () {
            if (!userScrolled) scrollToHeading(target, false);
          }, { once: true });
        }
      }
    }

    return {
      container: container,
      destroy: function () {
        container.removeEventListener('click', onClick);
        document.removeEventListener('keydown', onKeydown);
        document.removeEventListener('click', onDocumentClick);
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
        releaseEvents.forEach(function (type) {
          window.removeEventListener(type, releaseClicked);
        });
      }
    };
  }

  function initAll(root) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-article-toc]'), function (container) {
      if (container.hasAttribute('data-article-toc-initialized')) return;
      container.setAttribute('data-article-toc-initialized', '');
      var instance = init(container);
      if (instance) instances.push(instance);
    });
  }

  initAll(document);

  // Theme editor: re-initialise when the section is re-rendered.
  document.addEventListener('shopify:section:unload', function (event) {
    instances = instances.filter(function (instance) {
      if (event.target.contains(instance.container)) {
        instance.destroy();
        return false;
      }
      return true;
    });
  });
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
